import { useCallback, useRef, useState } from 'react';

// ─── Toast — shared bottom-right success/error notification ─────────────────
// Standard: DESIGN_SYSTEM.md §12 ("Variant A"). fixed bottom-right, solid color,
// ✓/✕ glyph, 3500ms auto-dismiss, no manual close button. Do not fork this file
// per-page — import useToast()/<Toast/> instead of copy-pasting the render block.

export interface ToastState {
  msg: string;
  error?: boolean;
}

export function useToast() {
  const [toast, setToast] = useState<ToastState | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const showToast = useCallback((msg: string, error = false) => {
    clearTimeout(timer.current);
    setToast({ msg, error });
    timer.current = setTimeout(() => setToast(null), 3500);
  }, []);

  return { toast, showToast };
}

export default function Toast({ toast }: { toast: ToastState | null }) {
  if (!toast) return null;
  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
      background: toast.error ? 'var(--accent-danger)' : 'var(--accent-success)',
      color: '#fff', borderRadius: 10, padding: '12px 18px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
      display: 'flex', alignItems: 'center', gap: 10,
      fontSize: '0.9rem', fontWeight: 500,
    }}>
      <span>{toast.error ? '✕' : '✓'}</span>
      <span>{toast.msg}</span>
    </div>
  );
}
